<template>
<v-card flat >
  <request-status :request='request' ></request-status>
  <v-alert :value='true' type='info' class='mt-0' >
    <strong>Note</strong>
    Automations (like automatically adding codes and invoice details) do not run for
    cloned appointments
    <v-btn small outline dark >Learn more <v-icon small class='ml-2' >open_in_new</v-icon> </v-btn>
  </v-alert>
  <v-list class='ma-0 pa-0 grey lighten-4'
    v-if='appointment' >
    <appointment-list-item
      :with-color-coding=false
      :with-action='false' :appointment='appointment' >
      <!-- <v-list-tile-action
        v-if='window === WINDOWS.CLIENT_CLONE || window === WINDOWS.DATE_CLONE'
        slot='actions' >
        <v-btn @click='window=0' small flat>
          <v-icon>chevron_left</v-icon>
          Back
        </v-btn>
      </v-list-tile-action> -->
    </appointment-list-item>
  </v-list>
  <v-divider ></v-divider>
  <v-toolbar
    dense flat
    v-if='window === WINDOWS.CLIENT_CLONE || window === WINDOWS.DATE_CLONE' >
    <v-btn @click='reset' small flat>
      <v-icon>chevron_left</v-icon>
      Back
    </v-btn>
    <v-divider vertical ></v-divider>
    <v-spacer></v-spacer>
    <v-checkbox
      v-model='withReminders'
      class="pa-0 ma-0 mt-4" label='Add reminders' ></v-checkbox>
    <v-checkbox
      v-model='copyCodes'
    class="pa-0 ma-0 mt-4"
      label='Copy codes' ></v-checkbox>
    <v-btn
      :disabled='selected.length===0 && selectedRelationshipsList.length===0'
      :loading='request.loading'
      color='primary' @click='save' >
      Create {{ selected.length || selectedRelationshipsList.length }} appointments</v-btn>
  </v-toolbar>
  <v-window v-model="window" vertical touchless >
    <v-window-item >
      <v-layout row wrap class='pt-0 mt-0'>
        <v-flex xs12 sm6 >
          <v-card class='elevation-10 ma-4'
            @click='window = WINDOWS.CLIENT_CLONE' >
            <v-card-title class='subtitle-1 overline' >
              Clone by client
            </v-card-title>
            <v-card-text>
              Copy all the information on this appointment across onto different clients
            </v-card-text>
            <v-card-actions >
              <v-spacer></v-spacer>
              <v-btn color='primary'>Clone by client</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 >
          <v-card class='elevation-10 ma-4'
            @click='window = WINDOWS.DATE_CLONE' >
            <v-card-title class='subtitle-1 overline' >
              Clone by date
            </v-card-title>
            <v-card-text>
              Create copies of this appointment for different dates
            </v-card-text>
            <v-card-actions >
              <v-spacer></v-spacer>
              <v-btn color='primary' >Clone by date</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-window-item>
    <v-window-item >
      <v-layout>
        <v-flex xs6 >
          <client-list :clear-on-select='false' class='pt-2 pl-4'
            @relationshipselected='relationshipselected' >
          </client-list>
        </v-flex>
        <v-flex xs6 >
          <v-list class='ma-3' >
            <v-subheader class="overline">
              Copy this appointment to these clients:
            </v-subheader>
            <client-list-item
              v-for='rel in selectedRelationshipsList'
              :key='rel.id' :client='rel.client' :relationship-id='rel.id'
              :with-action='false' >
              <v-list-tile-action slot='actions' >
                <v-btn @click='removeRelationship(rel)' icon >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-list-tile-action>
            </client-list-item>
            <v-list-tile v-if='selectedRelationshipsList.length === 0' >
              <v-list-tile-content>
                <v-list-tile-title>No clients selected</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <!-- <pre>{{payload}}</pre> -->
          </v-list>
        </v-flex>
      </v-layout>
    </v-window-item>
    <v-window-item >
      <v-card flat >
      <!-- {{selected}} -->
      <!-- E:{{events}} -->
      <v-divider></v-divider>
      <v-layout row wrap >
        <v-flex xs-4 >
          <v-date-picker
            no-title multiple show-current
            :allowed-dates="isAllowed"
            v-model="selected"
            v-for='month in months'
            :key='month' :scrollable='false'
            prev-icon='' next-icon=''
            :events='events'
            :disabled-dates='events'
            class='elevation-0 py-0 my-0'
            :picker-date="month" >
          </v-date-picker>
        </v-flex>
      </v-layout>
    </v-card>
    </v-window-item >
    <v-window-item >
      <v-flex xs-12 sm4 offset-sm4 >
        <v-card class='text-center justify-center mt-5 elevation-10' >
          <v-card-title class='subheading justify-center' >
            <v-icon :size=42 color='success' >check_circle</v-icon>
          </v-card-title>
          <v-card-title class='subheading justify-center' >
            Successfully created {{clones.length}} clones
          </v-card-title>
          <v-list >
            <template v-for='appt in clones' >
              <appointment-list-item :with-action='false' :appointment='appt' :key='appt.id' >
              </appointment-list-item>
            </template>
          </v-list>
          <v-divider></v-divider>
          <v-card-actions >
            <v-btn @click='$emit("close")' flat text >Done</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <!-- {{clones}} -->
    </v-window-item>
  </v-window>
</v-card>
</template>
<script>
import {DateTime} from 'luxon'

import AppointmentListItem from '@/components/appointment/AppointmentListItem'
import ClientListItem from '@/components/client/ClientListItem'
import ClientList from '@/components/client/ClientList'
import Vue from 'vue'

const WINDOWS = {
  START: 0,
  CLIENT_CLONE: 1,
  DATE_CLONE: 2,
  SUCCESS: 3
}

export default {
  name: 'CloneAppointment',
  components: { AppointmentListItem, ClientList, ClientListItem },
  props: {
    appointment: { type: Object, required: true },
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      window: 0,
      WINDOWS: WINDOWS,
      d: false,
      year: null,
      // months: [],
      selected: [],
      selectedRelationships: {},
      withReminders: false,
      copyCodes: true,
      request: {
        resource: 'ag.practitioner.appointments',
        extra: 'actions/clone',
        method: 'post'
      }
    }
  },
  computed: {
    events () {
      if (this.appointment && this.appointment.start_time) {
        return [DateTime.fromISO(this.appointment.start_time).toISODate()]
      }
    },
    appointmentId () {
      return this.getObjectPath(this.appointment, 'id', null)
    },
    selectedRelationshipsList () {
      if (this.selectedRelationships) {
        return Object.values(this.selectedRelationships)
      }
      return []
    },
    months () {
      let dt = DateTime.local()
      if (this.appointment && this.appointment.start_time) {
        dt = DateTime.fromISO(this.appointment.start_time)
      }
      this.year = dt.year
      this.month = dt.month
      let months = []
      for (let x = 0; x <= 7; x++) {
        let mo = dt.plus({ months: x })
        months.push(`${mo.year}-${mo.month}`)
      }
      return months
    },
    payload () {
      let data = {
        with_reminder: this.withReminders,
        copy_codes: this.copyCodes
      }
      if (this.window === WINDOWS.DATE_CLONE) {
        data['dates'] = this.selected.join(',')
      }
      if (this.window === WINDOWS.CLIENT_CLONE) {
        let relIds = Object.keys(this.selectedRelationships)
        data['relationships'] = relIds.join(',')
      }
      return data
    },
    requestStatus () {
      return this.request.status
    },
    clones () {
      return this.getObjectPath(this.request, 'result.clones', [])
    }
  },
  watch: {
    touch () {
      this.reset()
    },
    appointmentId () {
      this.reset()
    },
    requestStatus () {
      if (this.requestStatus === 200) {
        this.getAppointmentsInRange()
        this.window = WINDOWS.SUCCESS
        this.selected = []
        this.selectedRelationships = {}
      }
    }
  },
  methods: {
    reset () {
      this.selected = []
      this.selectedRelationships = {}
      this.window = 0
    },
    isAllowed (date) {
      if (this.events && this.events.length === 1) {
        return date !== this.events[0]
      }
      return true
    },
    relationshipselected (rel) {
      Vue.set(this.selectedRelationships, rel.id, rel)
    },
    removeRelationship (rel) {
      Vue.delete(this.selectedRelationships, rel.id)
    },
    save () {
      this.request.resourceId = this.appointment.id
      this.request.data = this.payload
      this.$request('save', this.request)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CloneAppointment.vue?08e0c8e3